import React from 'react';
import styled from '@emotion/styled';
import { SharedHero } from '@hover/shared-components';
import { Helmet } from 'react-helmet';
import { SDRLeadForm } from '../../../v2/components/lead/test-forms/MainForm';
import SDRCallUs from '../../../v2/components/lead/callUsParagraph';
import CallUsNavbarCta from '../../../v2/components/lead/callUsNavbarCta';
import LeadLayout from '../../../v2/components/lead/test-forms/Layout';

const CustomHero = styled(SharedHero)`
  .shared-hero__content {
    justify-content: flex-start;
    margin-top: 48px;
  }
  .shared-hero__image {
    max-height: 100% !important;
  }
`;

const MainLeadForm = () => (
  <LeadLayout title="Schedule a meeting" ctaButton={<CallUsNavbarCta />}>
    <Helmet>
      <script
        src="https://js.chilipiper.com/marketing.js"
        type="text/javascript"
        async
      />
    </Helmet>

    <CustomHero
      eyebrow="SCHEDULE YOUR 15-MIN CALL"
      heading="Talk to the HOVER team"
      body="Our team is ready to help! Fill out the form and select a date and time to meet."
      desktopImage={<SDRLeadForm />}
      mobileAndTabletImage={<SDRLeadForm />}
      contentChildren={<SDRCallUs />}
      page="lp/hover-sdr"
      mt={16}
    />
  </LeadLayout>
);

export default MainLeadForm;
